import { Remote } from './Remote';
export function isLinkRemote(link) {
    return link !== null && typeof link === 'object' && link instanceof Remote;
}
export {
    isLinkRemote as isRemote
};
export default isLinkRemote;    //# sourceMappingURL=isRemote.js.map
